import { dayjs } from '@shared/utils';
import { z } from 'zod';

const MAX_HISTORY_MONTHS = 24;

const selectionOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const QuestionnaireReportFilterSchema = z
  .object({
    examStartDate: z
      .date()
      .nullable()
      .refine((val) => !!val, { message: 'กรุณาเลือก Exam Start Date' }),
    examEndDate: z
      .date()
      .nullable()
      .refine((val) => !!val, { message: 'กรุณาเลือก Exam End Date' }),
    examCenter: z
      .array(selectionOptionSchema)
      .default([])
      .refine((val) => val.length > 0, { message: 'กรุณาเลือก Exam Center' }),
    examCourse: z
      .array(selectionOptionSchema)
      .default([])
      .refine((val) => val.length > 0, { message: 'กรุณาเลือก Exam Course' }),
  })
  .superRefine((data, ctx) => {
    if (data.examStartDate && data.examEndDate && data.examEndDate < data.examStartDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['examEndDate'],
        message: 'End Date ต้องไม่น้อยกว่า Start Date',
      });
    }

    if (data.examStartDate && data.examEndDate) {
      const endTime = dayjs(data.examEndDate).startOf('day');
      const maxEndTime = dayjs(data.examStartDate).startOf('day').add(MAX_HISTORY_MONTHS, 'month');
      if (endTime.isAfter(maxEndTime)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['examEndDate'],
          message: 'End Date ต้องไม่เกิน 24 เดือนนับจาก Start Date',
        });
      }
    }
  });

export type QuestionnaireReportFilterFormInput = z.input<typeof QuestionnaireReportFilterSchema>;
export type QuestionnaireReportFilterFormOutput = z.output<typeof QuestionnaireReportFilterSchema>;
